import { ApiEndpoints } from '../../constants/ApiEndpoints';
import { baseRequest } from '../../utils/HttpClient';

export const noteTimeStampForEvaluationContentBlock = (pathParams, queryParams) => {
  return baseRequest(ApiEndpoints.TREMBIT_SESSION_CONTENTBLOCK_TIMESTAMP, null, pathParams, queryParams);
};
